// 파일 input 선택 시 즉시 미리보기 표시 / clear 처리
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "clearButton"]

  openFileDialog() {
    this.inputTarget.click()
  }

  preview(event) {
    const file = event.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.innerHTML =
        `<img src="${e.target.result}" class="max-w-full max-h-[300px] object-contain">`
    }
    reader.readAsDataURL(file)
    this.#setClearEnabled(true)
  }

  clear() {
    this.inputTarget.value = ""
    this.previewTarget.innerHTML = `
      <div class="text-center text-[var(--gray-400)] py-10">
        <i data-lucide="image" class="mx-auto mb-2" style="width: 48px; height: 48px;"></i>
        <p class="text-sm">사진이 없습니다</p>
      </div>`
    if (window.lucide) window.lucide.createIcons()
    this.#setClearEnabled(false)
  }

  #setClearEnabled(enabled) {
    if (this.hasClearButtonTarget) this.clearButtonTarget.disabled = !enabled
  }
}
